// boingAndShineAnimation.js
var BoingAndShineAnimation = pc.createScript('boingAndShineAnimation');

BoingAndShineAnimation.attributes.add('shine',{type: 'entity'});
BoingAndShineAnimation.attributes.add('shineStartPosition',{type: 'number'});
BoingAndShineAnimation.attributes.add('shineEndPosition',{type: 'number'});
BoingAndShineAnimation.attributes.add('autoStartAnimation',{type: 'boolean',default: true});

BoingAndShineAnimation.prototype.initialize = function () {

    BoingAndShineAnimation.instance = this;

    if (this.autoStartAnimation) {
        this.stage1();
    }
};

BoingAndShineAnimation.prototype.stage1 = function () {

    this.shine.enabled = true;
    this.boingAndShineTweenAnim = this.shine.tween(this.shine.getLocalPosition()).to({ x: this.shineEndPosition, y: this.shine.getLocalPosition().y, z: this.shine.getLocalPosition().z }, 1, pc.Linear).on('complete', function () { BoingAndShineAnimation.instance.stage2(); });
    this.boingAndShineTweenAnim.start();
};

BoingAndShineAnimation.prototype.stage2 = function () {
    //console.log("p2");
    this.shine.enabled = false;
    this.entity
        .tween(this.entity.getLocalScale())
        .to(new pc.Vec3(0.8, 0.8, 0.8), 0.2, pc.Linear)
        .on('complete', function () { BoingAndShineAnimation.instance.stage3(); })
        .start();
};

BoingAndShineAnimation.prototype.stage3 = function () {
    this.shine.setLocalPosition(new pc.Vec3(this.shineStartPosition, 0, 0));
    this.entity
        .tween(this.entity.getLocalScale())
        .to(new pc.Vec3(1, 1, 1), 0.2, pc.Linear)
        .on('complete', function () { BoingAndShineAnimation.instance.stage1(); })
        .start();

};

BoingAndShineAnimation.prototype.startTween = function () {
    this.stage1();
};

BoingAndShineAnimation.prototype.stopTween = function () {
    //this.entity.script.boingAndShineAnimation.enabled = false;
    //this.boingAndShineTweenAnim.stop();
};



